import axios from 'axios';

const service = {

}

// "https://www.hkcd.com/api/news"
service.apiService = axios.create({
    baseURL: process.env.BASE_URL + 'news/',
    timeout: 20000 // 请求超时时间
})

// "https://www.hkcd.com/api/"
service.apiServiceApi = axios.create({
    baseURL: process.env.BASE_URL,
    timeout: 20000 // 请求超时时间
})

// 
service.apiServicePhp = axios.create({
    baseURL: process.env.AD_CHANNEL_ID,
    timeout: 20000 // 请求超时时间
})


export default service



// WEBPACK FOOTER //
// ./src/list/js/request.js